export const SESSION = {
  WARNING_BEFORE_MS: 2 * 60 * 1000, // Ostrzeżenie 2 minuty przed wylogowaniem z powodu bezczynności
  IDLE_THRESHOLD_MS: 2 * 60 * 60 * 1000, // 2 godziny bezczynności (Wariant B)
  TOKEN_REFRESH_BEFORE_MS: 5 * 60 * 1000, // Cichy auto-refresh na 5 minut przed wygaśnięciem 35-minutowego tokena JWT
};
